/*=========================================================================================
  File Name: moduleExpensesettingState.js
  Description: Expense Setting State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  expense_categories_with_childs: [],
};
